<template>
	<div style="background: #f5f5f5;">
		<template v-if="network_success">
			<!-- banner -->
			<banner></banner>
			<!-- banner end -->
			
			<!-- 专业版安装步骤 -->
			<pro-step 
				ref="proStep"
				:scrollTop="scrollTop"
				@emitOffsets="getProOffsets"
				@onVideoClick="handleProVideoClick"
			></pro-step>
			<!-- 专业版安装步骤 end -->
			
			<!-- 趣味版安装步骤 -->
			<fun-step 
				ref="funStep"
				:scrollTop="scrollTop" 
				@emitOffsets="getFunOffsets"
			></fun-step>
			<!-- 趣味版安装步骤 end -->
			
			<!-- 小器械训练 -->
			<instrument :list="instrument_list" @onClick="handleInstrumentClick"></instrument>
			<!-- 小器械训练 end -->
			
			<!-- 问答 -->
			<qa-box 
				ref="qa"
				:data="helps"
			></qa-box>
			<!-- 问答 end -->
			
			<!-- 专业版步骤索引 -->
			<pro-step-nav v-if="proStep_display" :index="proStep_index" @onClick="handleProStepNavClick"></pro-step-nav>
			<!-- 专业版步骤索引 end -->
			
			<!-- 趣味版步骤索引 -->
			<fun-step-nav v-if="funStep_display" :index="funStep_index" @onClick="handleFunStepNavClick"></fun-step-nav>
			<!-- 趣味版步骤索引 end -->
			
			<!-- 视频弹出框 -->
			<screen-video v-model="screen_play" :src="screen_src"></screen-video>
			<!-- 视频弹出框 end -->
		</template>
		
		<!-- 网络出错 -->
		<network-err v-if="!network_success" @onRefresh="handleNetworkRefresh"></network-err>
		<!-- 网络出错 end -->
	</div>
</template>

<script>
	import Banner from './components/banner.vue';
	import ProStep from './components/pro_step.vue';
	import FunStep from './components/fun_step.vue';
	import Instrument from './components/instrument.vue';
	import QaBox from './components/qa_box/qa_box.vue';
	import ProStepNav from './components/pro_step_nav.vue';
	import FunStepNav from './components/fun_step_nav.vue';
	import Api from '../../../api/api.js';
	import { mapMutations } from 'vuex';
	
	export default {
		created() {
			this.pro_offsets = [];
			this.fun_offsets = [];
			this.help_offset = 0;
		},
		mounted() {
			this.listenWindowScroll();
			this.init();
		},
		beforeDestroy() {
			this.removeListenWindowScroll();
		},
		data() {
			return {
				network_success: true,
				
				scrollTop: 0,
				
				proStep_display: false,
				proStep_index: 0,
				
				funStep_display: false,
				funStep_index: 0,
				
				screen_play: false,
				screen_src: '',
				
				instrument_list: [],
				
				helps: []
			}
		},
		methods: {
			/*************** @Events *******************/
			// 点击专业版小视频
			handleProVideoClick(src) {
				this.screen_src = src;
				this.screen_play = true;
			},
			// 点击专业版导航
			handleProStepNavClick(index) {
				let ele = document.documentElement || document.body;
				ele.scrollTop = this.pro_offsets[index];
			},
			// 点击趣味版导航
			handleFunStepNavClick(index) {
				let ele = document.documentElement || document.body;
				ele.scrollTop = this.fun_offsets[index];
			},
			// 点击小器械
			handleInstrumentClick(courseId) {
				this.getInstrumentDetail(courseId);
			},
			// 网络错误刷新
			handleNetworkRefresh() {
				this.init();
			},
			
			/*************** @Function *******************/
			// 初始化
			init() {
				const that = this;
				let ele = document.documentElement || document.body;
				let type = that.$route.query.type || '';
				that.getInstrumentData(() => {
					that.$refs.qa.getOffset((offsetTop) => {
						that.help_offset = offsetTop;
						type == 'pro' && (ele.scrollTop = that.pro_offsets[0]);
						type == 'fun' && (ele.scrollTop = that.fun_offsets[0]);
						type == 'help' && (ele.scrollTop = that.help_offset);
					});
				});
			},
			// 获取专业版每一步距离顶部的距离
			getProOffsets(offsets) {
				// console.log(offsets);
				this.pro_offsets = [...offsets];
			},
			// 获取趣味版每一步距离顶部的距离
			getFunOffsets(offsets) {
				// console.log(offsets);
				this.fun_offsets = [...offsets];
			},
			// 监听页面滚动
			listenWindowScroll() {
				window.addEventListener('scroll', this.windowScroll, false);
			},
			// 移除页面滚动监听
			removeListenWindowScroll() {
				window.removeEventListener('scroll', this.windowScroll, false);
			},
			windowScroll() {
				let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
				if (scrollTop >= this.pro_offsets[0] && scrollTop <= this.pro_offsets[this.pro_offsets.length - 1]) {
					if (scrollTop >= this.pro_offsets[0] && scrollTop < this.pro_offsets[1]) {
						this.proStep_index = 0;
					}
					if (scrollTop >= this.pro_offsets[1] && scrollTop < this.pro_offsets[2]) {
						this.proStep_index = 1;
					}
					if (scrollTop >= this.pro_offsets[2] && scrollTop < this.pro_offsets[3]) {
						this.proStep_index = 2;
					}
					if (scrollTop >= this.pro_offsets[3] && scrollTop < this.pro_offsets[4]) {
						this.proStep_index = 3;
					}
					if (scrollTop >= this.pro_offsets[4] && scrollTop < this.pro_offsets[5]) {
						this.proStep_index = 4;
					}
					this.proStep_display = true;
				} else {
					this.proStep_display = false;
				}
				if (scrollTop >= this.fun_offsets[0] && scrollTop <= this.fun_offsets[this.fun_offsets.length - 1]) {
					if (scrollTop >= this.fun_offsets[0] && scrollTop < this.fun_offsets[1]) {
						this.funStep_index = 0;
					}
					if (scrollTop >= this.fun_offsets[1] && scrollTop < this.fun_offsets[2]) {
						this.funStep_index = 1;
					}
					this.funStep_display = true;
				} else {
					this.funStep_display = false;
				}
				this.scrollTop = scrollTop;
			},
			// 获取小器械视频
			getInstrumentData(callBack) {
				const that = this;
				that.setLoading(true);
				let requestData = {
					firstId: 17,
					twoId: 24,
					pageNum: 1,
					limit: 12
				};
				Api.findCourseList(requestData).then((res) => {
					if (res.data.success) {
						that.instrument_list = res.data.data.data;
						that.getHelps(callBack);
					} else {
						that.setLoading(false);
						that.network_success = false;
					}
				}, () => {
					that.setLoading(false);
					that.network_success = false;
				});
			},
			// 获取帮助列表
			getHelps(callBack) {
				const that = this;
				let requestData = {
					id: 0,
					query: ''
				};
				Api.findHelpList(requestData).then((res) => {
					if (res.data.success) {
						that.setLoading(false);
						that.network_success = true;
						that.helps = res.data.data || [];
						that.$nextTick(() => {
							callBack && callBack();
						});
					} else {
						that.setLoading(false);
						that.network_success = false;
					}
				}, () => {
					that.setLoading(false);
					that.network_success = false;
				});
			},
			// 获取小器械视频详情
			getInstrumentDetail(courseId) {
				const that = this;
				that.setLoading(true);
				let requestData = {
					courseId: courseId
				};
				Api.getCourseDetail(requestData).then((res) => {
					if (res.data.success) {
						that.setLoading(false);
						that.screen_src = res.data.data.playUrl;
						that.screen_play = true;
					} else {
						that.setLoading(false);
						that.swal(res.data.message, {button: false});
					}
				}, (e) => {
					that.setLoading(false);
					that.swal(e.message, {button: false});
				});
			},
			...mapMutations({
				'setLoading': 'setLoading'
			})
		},
		watch: {
			screen_play(newVal) {
				newVal && this.$refs.proStep.pauseVideo();
				newVal && this.$refs.funStep.pauseVideo();
			}
		},
		components: {
			Banner,
			ProStep,
			FunStep,
			Instrument,
			QaBox,
			ProStepNav,
			FunStepNav
		}
	}
</script>

<style scoped>
</style>
